<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0" style="float: left">
            <button @click="redirect()" class="btn btn-primary btn-lg" style="font-size: 15px; margin-right: 15px">Voltar</button>
            Revisar documento

            <button
              class="btn btn-primary"
              style="margin-left: 15px"
              data-toggle="modal"
              data-target="#editar-cadastro-modal"
              type="button"
              @click="editar_cadastro = true"
            >
              Editar cadastro
            </button>

            <a href="/admin/fluxo_de_cadastros?filter=aguardando_liberacao" class="btn btn-primary btn-lg" style="font-size: 15px; margin-left: 15px">
              Fluxo cadastros (Aguardando liberação)
            </a>
          </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-8">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item"><a href="/admin/cadastros/todos">Todos os cadastros</a></li>
            <li class="breadcrumb-item">Detalhes</li>
            <li class="breadcrumb-item active">{{ user.id }}</li>
            <li class="breadcrumb-item">Documentos</li>
            <li class="breadcrumb-item active">{{ document.id }}</li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>

  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <br />

  <div class="row">
    <section class="col-lg-8">
      <div class="card" style="height: 98%">
        <div class="card-header">
          <h3 class="card-title">
            Documento

            <span v-if="document && document.verificado == 1" class="right badge badge-success" style="margin-left: 15px; font-size: 15px">
              Aprovado
            </span>

            <span v-if="document && document.verificado == 2" class="right badge badge-danger" style="margin-left: 15px; font-size: 15px">
              Reprovado
            </span>

            <div v-if="editar_validade">
              <br />
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <button type="button" class="btn btn-danger" id="confirmar" @click="editar_validade = false">Cancelar</button>
                </div>
                <InputMask id="basic" class="form-control" v-model="data_validade" placeholder="DD/MM/AAAA" mask="99/99/9999" slotChar="dd/mm/yyyy" />
                <span class="input-group-append">
                  <button type="button" class="btn btn-primary" id="confirmar" @click="atualizarValidade">Salvar</button>
                </span>
              </div>
            </div>

            <i
              style="cursor: pointer; margin-left: 25px; margin-right: 5px"
              v-if="document && document.verificado == 1 && !editar_validade"
              class="fa-solid fa-pen"
              @click="editar_validade = true"
            ></i>

            <span
              v-if="document && document.verificado == 1 && !editar_validade"
              class="right badge badge-success"
              :style="getStyleValidate(document)"
            >
              {{ converterValidade(document) }}
            </span>

            <a
              class="btn btn-danger btn-sm"
              style="cursor: pointer; margin-left: 5px"
              v-if="document && document.verificado == 1 && !editar_validade"
              @click="validarMax()"
            >
              MAX
            </a>
          </h3>
          <div class="card-tools">
            <button
              v-if="document && (document.verificado == 0 || document.verificado == 2) && !hide"
              class="btn btn-success btn-sm"
              style="margin-left: 15px"
              @click="confirmarAprovado()"
              type="button"
            >
              Aprovar
            </button>

            <button
              v-if="document && (document.verificado == 0 || document.verificado == 1) && !hide"
              class="btn btn-danger btn-sm"
              style="margin-left: 15px"
              @click="confirmarReprovado()"
              type="button"
            >
              Reprovar
            </button>

            <!--
            <button
              v-if="document && (document.verificado == 1 || document.verificado == 2) && !hide"
              class="btn btn-warning btn-sm"
              style="margin-left: 15px"
              @click="confirmarAguardando()"
              type="button"
            >
              Voltar para aguardando
            </button>
            -->

            <!-- 
                        <button v-if="document && document.verificado == 1" class="btn btn-primary btn-sm"
                            style="margin-left: 15px;" @click="marcarExpirado()" type="button">
                            Marcar como expirado
                        </button>
                        -->
          </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body">
          <div class="tab-content p-0">
            <object
              v-if="file_type == 'pdf' || file_type == 'PDF'"
              :data="getDocumentPath(document)"
              type="application/pdf"
              width="100%"
              height="600px"
            ></object>

            <img v-else :src="getDocumentPath(document)" />
          </div>
        </div>
        <!-- /.card-body -->
      </div>
    </section>
    <section class="col-lg-4">
      <div class="card" style="height: 98%">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-chart-pie mr-1"></i>
            Detalhes
          </h3>
        </div>
        <div class="card-body">
          <div class="tab-content p-0">
            <p>
              <strong>Apelido:</strong>
              &nbsp;{{ user.apelido }}
              <span class="right badge badge-danger" style="margin-left: 15px; background-color: #301904" v-if="user_profile.cadastro_tipo == 'pj'">
                PJ
              </span>
              <span class="right badge badge-danger" style="margin-left: 15px; background-color: blue" v-if="user_profile.cadastro_tipo == 'pf'">
                PF
              </span>
            </p>

            <div v-if="user_profile.cadastro_tipo == 'pj'">
              <p>
                <strong>CNPJ:</strong>
                {{ formatarCNPJ(user_profile.pj_cnpj) }}
                <br />
              </p>
              <p>
                <strong>Razão social:</strong>
                {{ user_profile.pj_razao_social }}
                <br />
              </p>
              <p>
                <strong>Nome fantasia:</strong>
                {{ user_profile.pj_nome_fantasia }}
                <br />
              </p>
              <p>
                <strong>Endereço da empresa:</strong>
                {{ user_profile.pj_endereco }}
                <br />
              </p>

              <p>
                <strong>Número:</strong>
                {{ user_profile.pj_endereco_num }}
                <br />
              </p>

              <p>
                <strong>Complemento:</strong>
                {{ user_profile.pj_endereco_complemento }}
                <br />
              </p>

              <p>
                <strong>Bairro:</strong>
                {{ user_profile.pj_endereco_bairro }}
                <br />
              </p>

              <p>
                <strong>CEP:</strong>
                {{ user_profile.pj_endereco_cep }}
                <br />
              </p>

              <p v-if="cidade_pj">
                <strong>Cidade/Estado:</strong>
                <span style="text-transform: uppercase">{{ cidade_pj.nome + "/" + estado_pj.sigla }}</span>
                <br />
              </p>
              <br />
            </div>

            <p>
              <strong>Id:</strong>
              {{ user_profile.id }}
              <br />
            </p>
            <p>
              <strong>Nome completo:</strong>
              {{ user_profile.nome_completo }}
              <br />
            </p>
            <p>
              <strong>Filiação:</strong>
              {{ user_profile.filiacao }}
              <br />
            </p>
            <p>
              <strong>Estado civil:</strong>
              <span style="text-transform: uppercase">{{ user_profile.estado_civil }}</span>
              <br />
            </p>
            <div v-if="is_casado">
              <p>
                <strong>Regime do casamento:</strong>
                <span style="text-transform: uppercase">{{ user_profile.regime_casamento }}</span>
                <br />
              </p>
            </div>
            <p>
              <strong>CPF:</strong>
              {{ formatarCPF(user_profile.cpf) }}
              <br />
            </p>
            <p>
              <strong>RG:</strong>
              {{ user_profile.rg }}
              <br />
            </p>
            <p>
              <strong>Expedição do RG:</strong>
              {{ formatDateNotTime(user_profile.rg_data_emissao) }}
              <br />
            </p>
            <p>
              <strong>Orgão emissor do RG:</strong>
              {{ user_profile.rg_orgao_exp }}
              <br />
            </p>
            <p>
              <strong>Data de nascimento:</strong>
              {{ formatDateNotTime(user_profile.data_nascimento) }}
              <br />
            </p>
            <p>
              <strong>Nacionalidade:</strong>
              {{ user_profile.nacionalidade }}
              <br />
            </p>
            <p>
              <strong>Naturalidade:</strong>
              {{ user_profile.naturalidade }}
              <br />
            </p>
            <p>
              <strong>Profissão:</strong>
              {{ user_profile.profissao }}
              <br />
            </p>
            <p></p>
            <br />
            <p>
              <strong>Data cadastro:</strong>
              {{ formatDate(user_profile.created_at) }}
              <br />
            </p>
            <p>
              <strong>Último login:</strong>
              {{ formatDate(user.login) }}
              <br />
            </p>
            <br />
            <p>
              <strong>Endereço:</strong>
              {{ user_profile.endereco }}
              <br />
            </p>
            <p>
              <strong>Número:</strong>
              {{ user_profile.endereco_num }}
              <br />
            </p>
            <p>
              <strong>Bairro:</strong>
              {{ user_profile.endereco_bairro }}
              <br />
            </p>
            <p>
              <strong>Complemento:</strong>
              {{ user_profile.endereco_complemento }}
              <br />
            </p>
            <p>
              <strong>Cep:</strong>
              {{ user_profile.endereco_cep }}
              <br />
            </p>
            <p v-if="cidade">
              <strong>Cidade/Estado:</strong>
              <span style="text-transform: uppercase">{{ cidade.nome + "/" + estado.sigla }}</span>
              <br />
            </p>
            <br />

            <div
              v-if="
                (user_profile.estado_civil == 'casado' ||
                  user_profile.estado_civil == 'uniao_estavel' ||
                  user_profile.estado_civil == 'solteiro_com_uniao_estavel') &&
                user_profile.cadastro_tipo == 'pf'
              "
            >
              <p>
                <strong>Nome cônjuge:</strong>
                {{ user_profile.conjuge_nome_completo }}
                <br />
              </p>
              <p>
                <strong>Filiação cônjuge:</strong>
                {{ user_profile.conjuge_filiacao }}
                <br />
              </p>
              <p>
                <strong>CPF cônjuge:</strong>
                {{ formatarCPF(user_profile.conjuge_cpf) }}
                <br />
              </p>
              <p>
                <strong>RG cônjuge:</strong>
                {{ user_profile.conjuge_rg }}
                <br />
              </p>
              <p>
                <strong>Expedição do RG cônjuge:</strong>
                {{ formatDateNotTime(user_profile.conjuge_rg_data_emissao) }}
                <br />
              </p>
              <p>
                <strong>Orgão emissor do RG cônjuge:</strong>
                {{ user_profile.conjuge_rg_orgao_exp }}
                <br />
              </p>
              <p>
                <strong>Data de nascimento cônjuge:</strong>
                {{ formatDateNotTime(user_profile.conjuge_data_nascimento) }}
                <br />
              </p>
              <p>
                <strong>Nacionalidade cônjuge:</strong>
                {{ user_profile.conjuge_nacionalidade }}
                <br />
              </p>
              <p>
                <strong>Naturalidade cônjuge:</strong>
                {{ user_profile.conjuge_naturalidade }}
                <br />
              </p>
              <p>
                <strong>Profissão cônjuge:</strong>
                {{ user_profile.conjuge_profissao }}
                <br />
              </p>
              <p>
                <strong>Sexo cônjuge:</strong>
                <span style="text-transform: uppercase">{{ user_profile.conjuge_sexo }}</span>
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- MODAL EDITAR CADASTRO -->
  <admin-editar-cadastro
    v-if="editar_cadastro"
    :orgaos_expedidores_rg="orgaos_expedidores_rg"
    :user_profile="user_profile"
    :user="user"
    :estados="estados"
    :cidades="my_cidades"
    :close="close"
    :action="buscarUserProfile"
    :cidades_pj="my_pj_cidades"
  />

  <!-- MODAL EMAIL DE PENDÊNCIAS -->
  <div class="modal fade" id="email-pendencias-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4>Email de pendências</h4>
            <br />

            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_info_geral">Assunto</label>
                <input class="form-control" id="nome" type="text" v-model="assunto_email_pendencias" autocomplete="name" />
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label for="leilao_info_geral">Conteúdo</label>

                <Editor style="background-color: white" editorStyle="height: 200px" v-model="corpo_email_pendencias" />
              </div>
            </div>

            <button @click="enviarEmailPendencias()" class="btn btn-primary btn-sm">Gravar pendência e Enviar e-mail</button>

            <button
              id="fechar_email_pendencias"
              style="margin-left: 15px"
              data-toggle="modal"
              data-target="#email-pendencias-modal"
              class="btn btn-danger btn-sm"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../mixins/auxController.js";
import AuxFormatacao from "../controller/auxFormatacao.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import InputMask from "primevue/inputmask";
import Editor from "primevue/editor";

export default {
  props: [
    "cidades",
    "cidades_pj",
    "estados",
    "cidade_pj",
    "estado_pj",
    "cidade",
    "estado",
    "my_document",
    "my_user_profile",
    "my_user",
    "voltar_cadastros",
  ],

  mixins: [sweetAlert, Swal, AuxController, AuxFormatacao],

  components: { Loading, InputMask, Editor },

  data() {
    return {
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      qtd_por_pagina: 25,
      pagina_atual: 1,
      inicio: 0,
      paginas: [],
      total: 0,
      users: [],
      verificado: "",
      reason: "",
      file_type: "",
      expira: 0,
      data_validade: "",
      corpo_email_pendencias: "",
      user_documents: "",
      hide: false,
      document: "",
      assunto_email_pendencias: "",
      editar_validade: false,
      is_casado: false,
      editar_cadastro: false,
      user_profile: "",
      user: "",
    };
  },

  mounted() {
    this.user = this.my_user;
    this.my_cidades = this.cidades;
    this.my_pj_cidades = this.pj_cidades;
    this.user_profile = this.my_user_profile;
    this.user_profile = this.my_user_profile;
    this.document = this.my_document;

    console.log(this.my_user_profile);
    console.log(this.estados);

    if (
      (this.user_profile.estado_civil == "casado" ||
        this.user_profile.estado_civil == "uniao_estavel" ||
        this.user_profile.estado_civil == "solteiro_com_uniao_estavel") &&
      this.user_profile.cadastro_tipo == "pf"
    ) {
      this.is_casado = true;
    }

    console.log(this.document);
    console.log(this.user_profile);

    this.getFileType();

    if (this.user_profile.cidade_id == null || this.user_profile.estado_id == null) {
      this.showErrorMessageWithButton("Ops...", "Os campos Cidade/Estado do usuário estão inválidos");
    }
    //this.buscarDocumentosEnviadosUsuario();
  },

  methods: {
    buscarUserProfile(cidades, cidades_pj) {
      this.my_cidades = cidades;
      this.my_pj_cidades = cidades_pj;

      let data = {
        id: this.user_profile.id,
      };

      axios
        .post(`/admin/user_profile/find`, data)
        .then((response) => {
          this.user_profile = response.data.user_profile;

          let data = {
            id: this.user.id,
          };

          axios
            .post(`/admin/user/find`, data)
            .then((response) => {
              this.user = response.data.user;
            })
            .catch((error) => {
              console.log(error);
              this.showErrorMessageWithButton("Ops..", "Falha ao localizar perfil do usuário");
              this.isLoading = false;
            });
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", "Falha ao localizar perfil do usuário");
          this.isLoading = false;
        });
    },

    close() {
      setTimeout(() => {
        this.editar_cadastro = false;
      }, "1 second");
    },

    getDocumentPath(document) {
      console.log("Doc");
      console.log(document);

      if (document) {
        if (document.path.includes("rochaleiloes3")) {
          return process.env.MIX_VUE_APP_S3_BASE3_URL + document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + document.path + "/" + document.arquivo;
        } else if (document.path.includes("rochaleiloes") || document.arquivo.includes("banner_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + document.path + "/" + document.arquivo;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + document.path + "/" + document.arquivo;
        }
      }
    },

    getStyleValidate(documento) {
      /*
            if (documento.expirado == 1) {
                return "background-color: red";
            } else if (documento.expira == 0) {
                return "background-color: green";
            } else {
                let data = this.formatDate(documento.expira_em);

                if (data != "Invalid date") {
                    let vencido = new Date() >= new Date(documento.expira_em);

                    if (vencido) {
                        return "background-color: orange";
                    } else {
                        return "background-color: green";
                    }
                }
            }*/

      let vencido = new Date() >= new Date(documento.expira_em);

      let style = "font-size: 15px;";

      if (vencido) {
        return style + "background-color: orange";
      } else {
        return style + "background-color: green";
      }
    },

    converterValidade(documento) {
      /*
            if (documento.expirado == 1) {
                return "Expirado";
            } else if (documento.expira == 0 || !documento.expira) {
                return " - "
            } else {
                this.data_validade = this.formatDateNotTime(documento.expira_em);

                return "Validade: " + this.formatDateNotTime(documento.expira_em);
            }*/
      this.data_validade = this.formatDateNotTime(documento.expira_em);

      return "Validade: " + this.formatDateNotTime(documento.expira_em);
    },

    confirmarAguardando() {
      this.$swal
        .fire({
          icon: "warning",
          title: "Confirmar reprovação",
          html: 'Deseja voltar o arquivo para "aguardando" ?',
          padding: "1.5em",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: 'Sim, voltar para "aguardando"!',
          cancelButtonText: "Cancelar",
        })
        .then((response) => {
          if (response) {
            this.aguardando();
          }
        });
    },

    aguardando() {
      let data = {
        id: this.document.id,
      };

      axios
        .post(`/admin/user/document/aguardando`, data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.document.verificado = 0;
            this.showSuccessMessage("Documento atualizado");
          } else {
            this.isLoading = false;

            let url = "";

            if (this.voltar_cadastros) {
              url = "/admin/cadastros/detalhes/" + this.user.id;
            } else {
              url = "/admin/user/document/" + this.user.id;
            }

            this.showErrorMessageWithButtonAndReload("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    confirmarReprovado() {
      this.$swal
        .fire({
          title: "Confirmar reprovação",
          icon: "warning",
          showCancelButton: true,
          html: '<label for="rejeicao">Motivo da rejeição:</label>' + '<textarea id="rejeicao" class="form-control" value="">',
          focusConfirm: false,
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            return [document.getElementById("rejeicao").value];
          },
        })
        .then((response) => {
          if (response) {
            this.reprovar(response);
          }
        });
    },

    confirmarAprovado() {
      this.$swal
        .fire({
          title: "Confirmar aprovação",
          icon: "success",
          showCancelButton: true,
          html: '<label for="nome">Expira em:</label>' + '<input id="input1" type="date" class="form-control" value="2099-12-31"><br/>',
          focusConfirm: false,
          cancelButtonText: "Cancelar",
          preConfirm: () => {
            return [document.getElementById("input1").value];
          },
        })
        .then((response) => {
          if (response) {
            this.aprovar(response);
          }
        });
    },

    aprovar(response) {
      if (!response.isDismissed) {
        let data = this.formatDateToSaveNew(response.value[0]);

        if (data == "Invalid date") {
          this.showErrorMessageWithButton("Ops...", "Data inválida");
        } else {
          this.verificado = 1;
          this.expira = 1;
          this.data_validade = data;

          this.salvar();
        }
      }
    },

    reprovar(response) {
      if (!response.isDismissed) {
        let data = this.formatDateToSaveNew(new Date());

        let motivo = response.value[0];

        if (data == "Invalid date") {
          this.showErrorMessageWithButton("Ops...", "Data inválida");
        } else {
          this.verificado = 2;
          this.expira = 0;
          this.data_validade = data;
          this.reason = motivo;

          console.log("DADOS");
          console.log(data);
          console.log(motivo);

          this.salvar();
        }
      }
    },

    converterTinyInt(value) {
      if (value == 0) {
        return "Não";
      } else if (value == 1) {
        return "Sim";
      }
    },

    buscarDocumentosEnviadosUsuario() {
      let data = {
        user_id: this.document.user_id,
      };

      axios
        .post(`/admin/document/search-by-user`, data)
        .then((response) => {
          let docs = response.data.documents;
          let todos_aprovados = true;
          let possui_aguardando = false;

          this.user_documents = docs;

          for (let i = 0; i < docs.length; i++) {
            if (docs[i].verificado == 0) {
              possui_aguardando = true;
            } else if (docs[i].verificado == 2) {
              todos_aprovados = false;
            }
          }

          if (!possui_aguardando && !todos_aprovados) {
            //EXIBIR MODAL COM PENDENTES/VENCIDOS
            this.gerarEmail();
          } else if (todos_aprovados && !possui_aguardando) {
            //EXIBIR MODAL PARA LIBERAR O CADASTRO
            this.showLotesBtnsOptionsPendencia();
          } else {
            this.redirect();
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
        });
    },

    gerarEmail() {
      console.log("Documentos");
      console.log(this.user_documents);

      this.corpo_email_pendencias = "Arquivos reprovados: <br/><br/>";
      this.corpo_pendencia = "Arquivos reprovados: <br/><br/>";

      let contPendentes = 0;
      let contExpirados = 0;

      let docs_expirados = [];

      for (let i = 0; i < this.user_documents.length; i++) {
        let document = this.user_documents[i];

        if (document.verificado == 2) {
          if (contPendentes > 0) {
            this.corpo_email_pendencias = this.corpo_email_pendencias + "<br/>";
          }

          //CORPO DO EMAIL
          contPendentes++;
          this.corpo_email_pendencias =
            this.corpo_email_pendencias + "Tipo:" + document.tipodoc + "<br/>" + "<b>Justificativa:</b> " + document.justificativa + "<br/>";

          //CORPO DA PENDENCIA REGISTRADO AO ENVIAR O E-MAIL
          this.corpo_pendencia =
            this.corpo_pendencia + "Tipo:" + document.tipodoc + "<br/>" + "<b>Justificativa:</b> " + document.justificativa + "<br/>";
        }

        let expirado = this.checkVencido(document);

        if (expirado) {
          docs_expirados.push(document);
          contExpirados++;
        }
      }

      //DOCUMENTOS VENCIDOS

      /*
      if (contPendentes > 0) {
        this.corpo_email_pendencias = this.corpo_email_pendencias + "<br/>Comprovantes vencidos:<br/><br/>";
      }

      for (let i = 0; i < docs_expirados.length; i++) {
        let document = docs_expirados[i];

        if (contExpirados > 0 && i > 0) {
          this.corpo_email_pendencias = this.corpo_email_pendencias + "<br/>";
        }

        this.corpo_email_pendencias =
          this.corpo_email_pendencias +
          "Tipo:" +
          document.tipodoc +
          "<br/>Nome: " +
          document.nome +
          "<br/><b>Justificativa:</b> " +
          document.justificativa +
          "<br/>";
      }
      */

      if (contPendentes > 0 || contExpirados > 0) {
        let data = {
          tipo: "Pendenciasuser",
        };

        axios
          .post(`/admin/mail_template/find_by_tipo`, data)
          .then((response) => {
            if (response.data.mail_template) {
              this.assunto_email_pendencias = response.data.mail_template.assunto;

              this.corpo_email_pendencias = response.data.mail_template.corpo + this.corpo_email_pendencias + response.data.mail_template.rodape;

              let btn = document.getElementById("fechar_email_pendencias");
              btn.click();
            } else {
              this.showErrorMessageWithButton("Ops...", "Email sem corpo ou sem assunto");
            }
          })
          .catch((error) => {
            console.log(error);
            this.isLoading = false;
          });
      } else {
        this.showErrorMessageWithButton("Ops...", "Nenhum documento com pendência");
      }
    },

    checkVencido(documento) {
      let data = this.formatDate(documento.expira_em);

      if (data != "Invalid date") {
        let vencido = new Date() >= new Date(documento.expira_em);

        return vencido;
      } else {
        return false;
      }
    },

    enviarEmailPendencias() {
      this.isLoading = true;

      let data = {
        user_id: this.user.id,
        assunto: this.assunto_email_pendencias,
        corpo: this.corpo_email_pendencias,
        pendencia: this.corpo_pendencia,
      };

      axios
        .post(`/admin/pendencia/enviar_email`, data)
        .then((response) => {
          this.isLoading = false;

          let btn = document.getElementById("fechar_email_pendencias");
          btn.click();

          this.showSuccessMessage("E-mail enviado");
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });

      console.log(this.acao_necessaria);
    },

    showLotesBtnsOptionsPendencia() {
      this.$swal
        .fire({
          icon: "success",
          html: "O que deseja fazer?",
          title: "Cadastro sem pendências!",
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: "Liberar e notificar",
          cancelButtonText: "Fechar",
          denyButtonText: "Liberar sem notificar",
        })
        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          console.log(result);
          if (result.isConfirmed) {
            this.updateStatus("liberar", true);
          } else if (result.isDenied && result.isDismissed == false) {
            this.updateStatus("liberar");
          } else if (result.isDismissed && result.dismiss == "cancel") {
            //window.location.href = "/admin/leilao/" + leilao_id + "/lotes/cadastrar_lote";
            //CLIQUE FORA
          } else if (result.isDismissed && result.dismiss == "backdrop") {
            //window.location.href = "/admin/leilao/" + leilao_id + "/lotes/cadastrar_lote";
          }
        });
    },

    updateStatus(acao, notificar) {
      this.isLoading = true;

      let msg = "";
      let status = "";

      if (acao == "bloquear") {
        msg = "Cadastro bloqueado";
        status = "bloqueado";
      } else if (acao == "liberar") {
        msg = "Cadastro liberado";
        status = "liberado";
      }

      let data = {
        user_id: this.user.id,
        status: status,
        notificar: notificar,
      };

      console.log(data);

      axios
        .post(`/admin/user/update_status`, data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessage(msg);

            let that = this;

            this.$swal
              .fire({
                icon: "success",
                title: "Sucesso",
                padding: "1.5em",
                text: msg,
              })
              .then(function () {
                that.redirect();
              });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButtonAndRefresh("Ops..", "Email já cadastrado!");
          this.isLoading = false;
        });
    },

    marcarExpirado() {
      let data = {
        id: this.document.id,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/document/expirado`, data)
        .then((response) => {
          this.showSuccessMessage("Data atualizada");

          this.document.expira_em = this.document;

          this.buscarDocumentosEnviadosUsuario();
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDateToSaveNew(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD");
    },

    validarMax() {
      this.$swal
        .fire({
          title: "Confirmação",
          html: "Deseja realmente definir a data de validade como data máxima (31/12/2099) ?",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
        })
        .then((result) => {
          if (result.value) {
            this.data_validade = "31/12/2099";
            this.atualizarValidade();
          }
        });
    },

    atualizarValidade() {
      let vencimento = this.formatDateToSave(this.data_validade);

      if (vencimento == "Invalid date") {
        this.showErrorMessageWithButton("Ops...", "Digite uma data válida");
      } else {
        let data = {
          id: this.document.id,
          data_validade: this.formatDateToSave(this.data_validade),
        };

        console.log("Buscando");
        console.log(data);

        axios
          .post(`/admin/document/validade`, data)
          .then((response) => {
            this.showSuccessMessage("Documento atualizado");

            this.editar_validade = false;

            this.redirect();

            //window.location.reload();
          })
          .catch((error) => {
            this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
            console.log(error.response.data);
          });
      }
    },

    salvar() {
      if (this.verificado == 1 || this.verificado == 2) {
        if (this.expira != 1 && this.expira != 0 && this.verificado == 1) {
          this.showErrorMessageWithButton("Ops...", "Define se o arquivo possui data de validade");
        } else {
          if (this.expira == 1 && (!this.data_validade || this.data_validade == "") && this.verificado == 1) {
            this.showErrorMessageWithButton("Ops...", "Defina a data de validade");
          } else {
            this.isLoading = true;

            let data = {
              id: this.document.id,
              verificado: this.verificado,
              reason: this.reason,
              expira: this.expira,
              data_validade: this.data_validade,
            };

            this.document.expira = this.expira;
            this.document.justificativa = this.reason;
            this.document.expira_em = this.data_validade;
            this.document.verificado = this.verificado;

            console.log("Buscando");
            console.log(data);

            axios
              .post(`/admin/user/document/verify`, data)
              .then((response) => {
                this.isLoading = false;

                if (response.data.success) {
                  this.hide = true;

                  this.showSuccessMessage("Documento verificado");

                  this.buscarDocumentosEnviadosUsuario();
                } else {
                  this.isLoading = false;

                  let url = "";

                  if (this.voltar_cadastros) {
                    url = "/admin/cadastros/detalhes/" + this.user.id;
                  } else {
                    url = "/admin/user/document/" + this.user.id;
                  }

                  this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, url);
                }
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        }
      } else {
        this.showErrorMessageWithButton("Ops...", "Escolha uma opção.");
      }
    },

    formatDateToSave(date) {
      return moment(date, "DD/MM/yyyy").format("yyyy-MM-DD");
    },

    redirect() {
      this.isLoading = true;

      if (this.voltar_cadastros) {
        window.location.href = "/admin/cadastros/detalhes/" + this.user.id;
      } else {
        window.location.href = "/admin/user/document/" + this.user.id;
      }
    },

    getFileType() {
      let arr = this.document.arquivo.split(".");
      this.file_type = arr[arr.length - 1];

      console.log("File = " + this.file_type);
      console.log(arr);
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    formatDateNotTime(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
strong {
  margin-right: 3px;
}

p {
  margin-top: -10px;
}

.check-card {
  width: 100%;
  height: 250px;
  text-align: center;
  cursor: pointer;
}

img {
  max-width: 100%;
  max-height: 100%;
}

textarea:focus {
  border-color: gray;
}

.rejeitado {
  border-style: solid;
  border-width: thin;
  border-color: red;
}

.aprovado {
  border-style: solid;
  border-width: thin;
  border-color: green;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
